import {
  animate,
  animateChild,
  group,
  query,
  style,
  transition,
  trigger,
} from '@angular/animations';
export const routeTransitions = trigger('animTrigger', [
  transition('calendar => form', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          right: 0,
          width: '100%',
        }),
      ],
      { optional: true }
    ),
    query(':enter', [style({ right: '-40px', opacity: 0 })], {
      optional: true,
    }),
    group([
      query(
        ':leave',
        [animate('300ms ease-in-out', style({ right: '40px', opacity: 0 }))],
        { optional: true }
      ),
      query(
        ':enter',
        [animate('300ms ease-in-out', style({ right: '0', opacity: 1 }))],
        { optional: true }
      ),
    ]),
    query(':leave', animateChild(), { optional: true }),
    query(':enter', animateChild(), { optional: true }),
  ]),
  transition('form => calendar', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          right: 0,
          width: '100%',
        }),
      ],
      { optional: true }
    ),
    query(':enter', [style({ right: '40px', opacity: 0 })], { optional: true }),
    group([
      query(
        ':leave',
        [animate('300ms ease-in-out', style({ right: '-40px', opacity: 0 }))],
        { optional: true }
      ),
      query(
        ':enter',
        [animate('300ms ease-in-out', style({ right: '0', opacity: 1 }))],
        { optional: true }
      ),
    ]),
    query(':leave', animateChild(), { optional: true }),
    query(':enter', animateChild(), { optional: true }),
  ]),
]);
